import { ErrorMessage } from '@/modules/common/components/ErrorMessage';
import { IUser } from '@/types/user';
import { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import React, { Suspense } from 'react';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then(res => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

const ReactQueryDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/react-query-devtools').then(res => ({
          default: res.ReactQueryDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  user?: IUser;
}>()({
  component: () => (
    <>
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
      <Suspense>
        <div className="absolute bottom-12 left-2">
          <ReactQueryDevtools buttonPosition="relative" />
        </div>
      </Suspense>
    </>
  ),
  errorComponent: ({ error, reset }) => {
    return <ErrorMessage error={error} reset={reset} />;
  },
  notFoundComponent: () => {
    return <ErrorMessage error={{ statusCode: 404 }} reset={() => null} />;
  },
});
